import React, { useMemo } from "react";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
export var StepTime = function (_a) {
    var formData = _a.formData, availableSlots = _a.availableSlots, onUpdate = _a.onUpdate, onNext = _a.onNext;
    var availableTimes = useMemo(function () {
        if (!formData.appointmentDate)
            return [];
        // Format the selected date to match the slot date format (YYYY-MM-DD)
        var selectedDateStr = format(formData.appointmentDate, "yyyy-MM-dd");
        // Find the slot for the selected date
        var dateSlot = availableSlots.find(function (slot) { return slot.date === selectedDateStr; });
        return (dateSlot === null || dateSlot === void 0 ? void 0 : dateSlot.times) || [];
    }, [formData.appointmentDate, availableSlots]);
    var handleTimeSelect = function (time) {
        onUpdate({ appointmentTime: time.time });
        onNext();
    };
    if (!formData.appointmentDate) {
        return (React.createElement("div", { className: "flex flex-col items-center justify-center min-h-[200px]" },
            React.createElement("p", { className: "text-muted-foreground" }, "Please select a date first")));
    }
    return (React.createElement("div", { className: "flex flex-col items-center" },
        React.createElement("h3", { className: "text-xl font-semibold mb-4 text-center" },
            "Available times for",
            " ",
            format(formData.appointmentDate, "EEEE, MMMM d, yyyy")),
        React.createElement("div", { className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 w-full max-w-2xl" }, availableTimes.length > 0 ? (availableTimes
            .filter(function (time) { return time.available; })
            .map(function (time) { return (React.createElement(Button, { key: time.time, variant: "outline", size: "lg", className: "h-14", onClick: function () { return handleTimeSelect(time); } }, time.time)); })) : (React.createElement("p", { className: "col-span-full text-center text-muted-foreground py-8" }, "No available times for this date."))),
        availableTimes.length > 0 && (React.createElement("p", { className: "text-sm text-muted-foreground mt-6 text-center" }, "Select a time to continue"))));
};
